import * as React from 'react';
import { useTheme } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import * as Device from 'react-device-detect';

import { useSession, useStatusBarScrollToTop } from '@hooks';
import { createBookingVar } from '@context';

export const MobileCalendarHeader = React.memo(() => {
  const [isDisabled, setIsDisabled] = React.useState(false);
  const { account } = useSession();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const theme = useTheme();

  React.useEffect(() => {
    const date = searchParams.get('date');
    const isBefore = date ? moment(date).isBefore(moment(), 'day') : false;
    setIsDisabled(isBefore);
  }, [isDisabled, searchParams]);

  // Handle iOS status bar tap to scroll to top
  const scrollRef = React.useRef<HTMLDivElement | null>(null);
  useStatusBarScrollToTop(scrollRef);

  const handleOpenCreate = () => {
    const variant = pathname
      .split('/')
      .filter(Boolean)
      .find((segment) => ['booking', 'event'].includes(segment)) as 'booking' | 'event';

    const date = searchParams.get('date') ?? moment().format('YYYY-MM-DD');

    if ((!variant && account?.__typename === 'Consumer') || variant === 'event') {
      navigate(`/me/calendar/event/create?date=${date}`, { state: { from: `${pathname}?date=${date}` } });
    } else if (variant === 'booking') {
      createBookingVar(true);
    }
  };

  const tabNameMap = {
    '/me/calendar': 'Agenda',
    '/me/calendar/booking': 'Bookings',
    '/me/calendar/event': 'Events',
  };

  if (Device.isDesktop) {
    return null;
  }

  return (
    <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center" ref={scrollRef}>
      <Typography variant="h4">{tabNameMap[pathname as keyof typeof tabNameMap] || 'Agenda'}</Typography>
      {['Consumer', 'Spot'].includes(account?.__typename ?? '') && (
        <IconButton onClick={handleOpenCreate} disabled={isDisabled}>
          <theme.icons.add fontSize="large" />
        </IconButton>
      )}
    </Stack>
  );
});
